import { ReferenceTypeDTO } from "src/app/api/api-types";
import { getEnumMember } from "src/utils";

export enum SiteStatusEnum {
  Inactive = "Inactive",
  Live = "Live",
  Pending = "Pending",
}

export class SiteStatus {
  private constructor(args: ClassProperties<SiteStatus>) {
    this.name = args.name;
    this.id = args.id;
  }

  public readonly name: SiteStatusEnum;
  public readonly id: number;

  public static deserialize(data: ReferenceTypeDTO): SiteStatus {
    return new SiteStatus({
      name: getEnumMember(SiteStatusEnum, data.value),
      id: data.id,
    });
  }

  public static deserializeList(
    data: ReferenceTypeDTO[],
  ): readonly SiteStatus[] {
    return data.map((x) => SiteStatus.deserialize(x)) || [];
  }
}
